import { HttpClient, HttpParams } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { pipe, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";

import moment from "moment-timezone";
import { UtilServiceService } from "./utilService/util-service.service";

@Injectable({
  providedIn: "root",
})
export class ShiftsService {
  public refreshList$: EventEmitter<any>;
  private ENDPOINT_CREATE_SHIFT = "/user-shifts";
  private ENDPOINT_DELETE_TASK = "/user-shifts/";
  private ENDPOINT_SHIFT_TYPES = "/shift-types";
  private ENDPOINT_SHIFT_ASSIGNMENTS = "/shift-assignments";
  private ENDPOINT_USER_TYPES = "/user-types"; //dd
  private ENDPOINT_ACCESS_Profiles = "/profiles"; //dd
  private ENDPOINT_ALL_TEAMS = "/teams/get-all-teams"; //dd
  private ENDPOINT_ALL_USERS = "/v4/get-all-users"; //dd
  private ENDPOINT_CANCEL_SHIFT = "/user-shifts/request-cancellation";
  private ENDPOINT_REJECT_SHIFT = "/user-shifts/status";
  private ENDPOINT_USER_SHIFTS_INFO_FILTER = "/user-shifts/info/filter";
  private ENDPOINT_USER_SHIFTS_CANCEL_REQUESTS =
    "/user-shifts/cancellation-requests";

  public dateEmit$: EventEmitter<any> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private util: UtilServiceService,
  ) {
    this.refreshList$ = new EventEmitter();
  }

  /********************************** Create Shift Type **************************/
  public createShiftType(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_SHIFT_TYPES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(body);
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  /********************************** Get Shift Type By Id **************************/
  public getShiftTypeById(shiftTypeId: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_SHIFT_TYPES + "/" + shiftTypeId, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  /********************************** Update Shift Type **************************/
  public updateShiftType(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_SHIFT_TYPES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(body);
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  /********************************** Delete Shift Type **************************/
  public deleteShiftType(shiftTypeId: any, force: boolean = false) {
    const params = new HttpParams().set("force", String(force));
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_SHIFT_TYPES + "/" + shiftTypeId,
        {
          observe: "response",
          params,
        }
      )
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Shift Type");
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  /********************************** Bulk Delete Shift Assignments **************************/
  public bulkDeleteShiftAssignments(assignmentIds: (number | string)[]) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/bulk", {
        observe: "response",
        body: assignmentIds,
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Shift Assignments");
          return resp;
        }),
        catchError((error: any) => throwError(error))
      );
  }

  /********************************** Delete Single Shift Assignment **************************/
  public deleteShiftAssignment(shiftAssignmentId: any) {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/" + shiftAssignmentId,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Shift Assignment");
          return resp;
        }),
        catchError((error: any) => throwError(error))
      );
  }

  /********************************** Get Shift Assignment By Id **************************/
  public getShiftAssignmentById(shiftAssignmentId: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/" + shiftAssignmentId,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error: any) => throwError(error))
      );
  }

  /********************************** Get Shift Assignments By User Id **************************/
  // public getShiftAssignmentsByUserId(userId: any) {
  //   return this.http
  //     .get(
  //       environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/user/" + userId,
  //       { observe: "response" }
  //     )
  //     .pipe(
  //       map((resp: any) => resp),
  //       catchError((error: any) => throwError(error))
  //     );
  // }

  /** Direct assignments and shifts inherited from the user's groups. */
  public getApplicableShiftAssignments(userId: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/applicable/" + userId,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error: any) => throwError(error))
      );
  }

  /********************************** Get Shift Assignments By Group Id **************************/
  public getShiftAssignmentsByGroupId(groupId: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/user-group/" + groupId,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error: any) => throwError(error))
      );
  }

  /********************************** Shift Types (server-side pagination) **************************/
  public getShiftTypes() {
   
    return this.http
      .get(environment.base_url + this.ENDPOINT_SHIFT_TYPES, {
        observe: "response"
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  /********************************** Active Shift Types **************************/
  public getActiveShiftTypes() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_SHIFT_TYPES + "/active", {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  /********************************** Create Shift Assignment **************************/
  public createShiftAssignment(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(body);
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  /********************************** Update Shift Assignment **************************/
  public updateShiftAssignment(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(body);
          return resp;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  /********************************** Bulk View Shift Assignments (paged) **************************/
  /**
   * Users  → GET /shift-assignments/bulk-view/paged?assigneeType=USER&...
   * Groups → GET /shift-assignments/bulk-view/groups/paged?...
   */
  public getBulkShiftAssignmentsPaged(filters: {
    assigneeType?: string;
    userGroupId?: any;
    userIds?: any;
    shiftTypeId?: any;
    status?: string | null;
    search?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
    page?: number;
    perPage?: number;
    columnName?: string;
    sortOrder?: string;
  } = {}) {
    const isGroupsView =
      String(filters.assigneeType || '').toUpperCase() === 'USER_GROUP' ||
      String(filters.assigneeType || '').toUpperCase() === 'GROUP';

    const endpoint = isGroupsView
      ? this.ENDPOINT_SHIFT_ASSIGNMENTS + '/bulk-view/groups/paged'
      : this.ENDPOINT_SHIFT_ASSIGNMENTS + '/bulk-view/paged';

    let params = new HttpParams()
      .set('page', String(filters.page ?? 1))
      .set('perPage', String(filters.perPage ?? 25))
      .set('columnName', filters.columnName || 'assigneeName')
      .set('sortOrder', filters.sortOrder || 'asc');

    // Users endpoint requires assigneeType=USER
    if (!isGroupsView) {
      params = params.set('assigneeType', 'USER');
    }

    // Groups: userGroupId supports single id or comma-separated list
    if (filters.userGroupId != null && filters.userGroupId !== '' && filters.userGroupId !== 'all') {
      const groupIds = Array.isArray(filters.userGroupId)
        ? filters.userGroupId.filter((id: any) => id != null && id !== '')
        : [filters.userGroupId];
      if (groupIds.length) {
        params = params.set('userGroupIds', groupIds.join(','));
      }
    }

    // Users API uses userIds (comma-separated)
    if (!isGroupsView) {
      const userIds =
        filters.userIds != null && filters.userIds !== '' ? filters.userIds : null;
      if (userIds != null && userIds !== '' && userIds !== 'all') {
        const ids = Array.isArray(userIds)
          ? userIds.filter((id: any) => id != null && id !== '')
          : [userIds];
        if (ids.length) {
          params = params.set('userIds', ids.join(','));
        }
      }
    }

    if (filters.shiftTypeId != null && filters.shiftTypeId !== '' && filters.shiftTypeId !== 'all') {
      params = params.set('shiftTypeId', String(filters.shiftTypeId));
    }
    if (filters.status && filters.status !== 'all') {
      params = params.set('status', filters.status);
    }
    if (filters.search != null && String(filters.search).trim() !== '') {
      params = params.set('search', String(filters.search).trim());
    }
    // Both APIs use `from` / `to` ISO dates
    if (filters.fromDate) {
      params = params.set('from', this.toBulkViewIsoDate(filters.fromDate));
    }
    if (filters.toDate) {
      params = params.set('to', this.toBulkViewIsoDate(filters.toDate, true));
    }

    return this.http
      .get(environment.base_url + endpoint, {
        observe: 'response',
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error: any) => throwError(error))
      );
  }

  /** Normalize date to API format used by bulk-view endpoints */
  private toBulkViewIsoDate(value: string, endOfDay = false): string {
    if (!value) {
      return value;
    }
    if (value.includes('T')) {
      return value.endsWith('Z') ? value : value + 'Z';
    }
    const time = endOfDay ? '23:59:00' : '00:00:00';
    return this.util
      .timeFormatter(
        moment(time, 'h:mm A').format('h:mm A'),
        moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD')
      )
      .toISOString();
  }

  /********************************** Download Shift Assignment Import Sample **************************/
  public downloadShiftAssignmentImportSample() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/import/sample", {
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error: any) => throwError(error))
      );
  }

  /********************************** Validate Shift Assignment Import (preview) **************************/
  public validateShiftAssignmentImport(file: File) {
    const formData = new FormData();
    formData.append("file", file, file.name);

    return this.http
      .post(
        environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/import/validate",
        formData,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error: any) => throwError(error))
      );
  }

  /********************************** Apply Shift Assignment Import **************************/
  public applyShiftAssignmentImport(file: File) {
    const formData = new FormData();
    formData.append("file", file, file.name);

    return this.http
      .post(
        environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/import",
        formData,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error: any) => throwError(error))
      );
  }

  /********************************** Export Bulk Shift Assignments **************************/
  public exportBulkShiftAssignments(filters: {
    assigneeType?: string;
    userGroupId?: any;
    userId?: any;
    userIds?: any;
    shiftTypeId?: any;
    status?: string | null;
    search?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
    timezone?: string | null;
  } = {}) {
    let params = new HttpParams();

    if (filters.assigneeType) {
      params = params.set("assigneeType", filters.assigneeType);
    }
    if (filters.userGroupId != null && filters.userGroupId !== "" && filters.userGroupId !== "all") {
      const groupIds = Array.isArray(filters.userGroupId)
        ? filters.userGroupId.filter((id: any) => id != null && id !== "")
        : [filters.userGroupId];
      if (groupIds.length) {
        params = params.set("userGroupIds", groupIds.join(","));
      }
    }
    const exportUserIds =
      filters.userIds != null && filters.userIds !== ""
        ? filters.userIds
        : filters.userId;
    if (exportUserIds != null && exportUserIds !== "" && exportUserIds !== "all") {
      const ids = Array.isArray(exportUserIds)
        ? exportUserIds.filter((id: any) => id != null && id !== "")
        : [exportUserIds];
      if (ids.length) {
        params = params.set("userIds", ids.join(","));
      }
    }
    if (filters.shiftTypeId != null && filters.shiftTypeId !== "" && filters.shiftTypeId !== "all") {
      params = params.set("shiftTypeId", String(filters.shiftTypeId));
    }
    if (filters.status && filters.status !== "all") {
      params = params.set("status", filters.status);
    }
    if (filters.search != null && String(filters.search).trim() !== "") {
      params = params.set("search", String(filters.search).trim());
    }
    if (filters.fromDate) {
      params = params.set("from", this.toBulkViewIsoDate(filters.fromDate));
    }
    if (filters.toDate) {
      params = params.set("to", this.toBulkViewIsoDate(filters.toDate, true));
    }
    if (filters.timezone) {
      params = params.set("timezone", filters.timezone);
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_SHIFT_ASSIGNMENTS + "/export", {
        observe: "response",
        responseType: "blob",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error: any) => throwError(error))
      );
  }

  //add
  public createShift(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_CREATE_SHIFT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(body);
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  //edit
  public editShift(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_CREATE_SHIFT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(body);
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  //dd
  public getUsers(
    userTypeId: any,
    teamId: any,
    profileId: any,
    managerId: any,
    shift: any
  ) {
    let params = new HttpParams();
    if (userTypeId) params = params.set("userTypeId", userTypeId);
    if (teamId) params = params.set("teamId", teamId);
    if (profileId) params = params.set("profileId", profileId);
    if (managerId) params = params.set("managerId", managerId);
    params = params.set("shift", shift); //boolean
    return this.http
      .get(environment.base_url + this.ENDPOINT_ALL_USERS, {
        observe: "response",
        params: params,
      })

      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  //dd
  public getUserTypes() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_USER_TYPES, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  //dd
  public getAccessProfiles() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ACCESS_Profiles, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  //dd
  public getAllTeams(id: any) {
    let params = new HttpParams().set("userId", id);
    return this.http
      .get(environment.base_url + this.ENDPOINT_ALL_TEAMS, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status == 204) {
            return false;
          } else {
            return resp.body;
          }
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  //3rd tab grid call
  public getAllCancelShifts(assignedByUserId: any) {
    let params = new HttpParams().set("assignedByUserId", assignedByUserId);
    return this.http
      .get(environment.base_url + this.ENDPOINT_USER_SHIFTS_CANCEL_REQUESTS, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status == 204) {
            return false;
          } else {
            return resp.body;
          }
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public deleteShift(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_DELETE_TASK + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Task");
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public cancelShift(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_CANCEL_SHIFT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(body);
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public rejectShift(shiftId: any, status: any) {
    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_REJECT_SHIFT +
          "?shiftId=" +
          shiftId +
          "&status=" +
          status,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Check In Task");
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public getMyShiftsInfo(
    fromDate: any,
    toDate: any,
    withLeave: any,
    isMyShift: any
  ) {
    let params = new HttpParams();
    if (toDate) {
      params = params.set("fromDate", fromDate).set("toDate", toDate);
    } else {
      params = params
        .set("fromDate", moment().format("YYYY-MM-DD"))
        .set("toDate", moment().format("YYYY-MM-DD"));
    }
    if (withLeave) params = params.set("withLeave", withLeave);
    if (isMyShift) params = params.set("isMyShift", isMyShift);
    return this.http
      .get(environment.base_url + this.ENDPOINT_USER_SHIFTS_INFO_FILTER, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status == 204) {
            return false;
          } else {
            return resp.body;
          }
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public getStaffShiftsInfo(
    fromDate: any,
    toDate: any,
    userTypeId: any,
    teamId: any,
    profileId: any,
    withLeave: any,
    isMyShift: any
  ) {
    let params = new HttpParams();
    if (toDate) {
      params = params.set("fromDate", fromDate).set("toDate", toDate);
    } else {
      params = params
        .set("fromDate", moment().format("YYYY-MM-DD"))
        .set("toDate", moment().format("YYYY-MM-DD"));
    }

    if (userTypeId) params = params.set("userTypeId", userTypeId);
    if (teamId) params = params.set("teamId", teamId);
    if (profileId) params = params.set("profileId", profileId);
    if (withLeave) params = params.set("withLeave", withLeave);
    if (isMyShift) params = params.set("isMyShift", isMyShift);
    return this.http
      .get(environment.base_url + this.ENDPOINT_USER_SHIFTS_INFO_FILTER, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status == 204) {
            return false;
          } else {
            return resp.body;
          }
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public emitDateChange(date: any, view: any) {
    this.dateEmit$.emit({ date: date, view: view });
  }
}
